<style scoped>
@media print {
  @page {
    margin: 2mm 5mm 0mm 5mm;
    size: 216mm 140mm;
  }

  thead {
    display: table-header-group;
  }

  .page-break {
    page-break-before: always;
  }

  body {
    font-family: "Courier", monospace !important;
    height: 100% !important;
    color: black !important;
    background-color: white !important;
    transform: scale(1);
    transform-origin: top left;
  }

  table {
    width: 100% !important;
    color: black !important;
    font-size: 8.5pt !important;
    font-family: "Courier";
    line-height: normal;
  }

  thead {
    display: table-header-group !important;
  }

  th,
  td {
    /* font-size: 10pt; */
    text-align: left;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
  }
}
</style>

<template>
  <div>
    <div
      v-for="(dataPerDoc, dataPerDocIndex) in allData"
      :key="`dataPerDoc-${dataPerDoc.delivery_order_code}-${dataPerDocIndex}`"
    >
      <div
        v-for="(dl, dlIndex) in dataPerDoc.lines"
        :key="`lines-${dataPerDoc.delivery_order_code}-${dlIndex}`"
        style="page-break-before: always"
      >
        <!-- header -->
        <table width="100%">
          <tr>
            <td colspan="6" style="text-align: center; padding-bottom: 4px">
              <div><strong>PROFORMA INVOICE</strong></div>
              <div>
                <strong>{{ dataPerDoc.company_name }}</strong>
              </div>
            </td>
          </tr>

          <tr
            v-for="(h, hIndex) in dl.header"
            :key="`header-row-${dataPerDoc.delivery_order_code}-${hIndex}`"
          >
            <td
              v-for="(col, colIndex) in h"
              :key="`header-col-${dataPerDoc.delivery_order_code}-${hIndex}-${colIndex}`"
              :colspan="col.colspan"
              :rowspan="col.rowspan"
              :style="col.style"
            >
              {{ col.value }}
            </td>
          </tr>
        </table>
        <div style="height: 5px"></div>
        <table width="100%" border="0">
          <thead>
            <tr
              v-for="(lh, lhIndex) in dl.item_header"
              style="border-top: 2px dashed; border-bottom: 2px dashed"
              :key="`line-header-row-${dataPerDoc.delivery_order_code}-${dlIndex}-${lhIndex}`"
            >
              <th
                v-for="(col, colIndex) in lh"
                :key="`line-header-col-${dataPerDoc.delivery_order_code}-${dlIndex}-${lhIndex}-${colIndex}`"
                :colspan="col.colspan"
                :rowspan="col.rowspan"
                :style="col.style"
              >
                {{ col.value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-for="(rowGroup, rowGroupIndex) in dl.item_body">
              <tr
                v-for="(rowGroupSub, rowGroupSubIndex) in rowGroup"
                :key="`line-row-${dataPerDoc.delivery_order_code}-${dlIndex}-${rowGroupIndex}-${rowGroupSubIndex}`"
              >
                <td
                  v-for="(col, colIndex) in rowGroupSub"
                  :key="`line-col-${dataPerDoc.delivery_order_code}-${dlIndex}-${rowGroupIndex}-${rowGroupSubIndex}-${colIndex}`"
                  :colspan="col.colspan"
                  :rowspan="col.rowspan"
                  :style="col.style"
                  style="padding: 0 2px"
                >
                  {{ col.value }}
                </td>
              </tr>
            </template>

            <tr
              v-for="(value, lfIndex) in dl.item_footer"
              :key="`line-footer-row-${dataPerDoc.delivery_order_code}-${dlIndex}-${lfIndex}`"
            >
              <th
                v-for="(col, colIndex) in value"
                :key="`line-footer-col-${dataPerDoc.delivery_order_code}-${dlIndex}-${lfIndex}-${colIndex}`"
                :colspan="col.colspan"
                :rowspan="col.rowspan"
                :style="col.style"
              >
                <div v-html="col.value"></div>
              </th>
            </tr>
            <tr v-if="dl.item_footer.length == 0 && dl.item_body.length > 0">
              <td colspan="100%" style="border-top: 2px dashed"></td>
            </tr>
          </tbody>
        </table>

        <!-- signature -->
        <div style="height: 2px"></div>
        <table width="100%" border="0">
          <tr
            v-for="(ls, lsIndex) in dl.siganture_sec"
            :key="`line-signature-row-${dataPerDoc.delivery_order_code}-${lsIndex}`"
          >
            <td
              v-for="(col, colIndex) in ls"
              :key="`line-signature-col-${dataPerDoc.delivery_order_code}-${lsIndex}-${colIndex}`"
              :colspan="col.colspan"
              :rowspan="col.rowspan"
              :style="col.style"
            >
              <div v-html="col.value"></div>
            </td>
          </tr>
        </table>

        <!-- footer -->
        <div style="height: 2px"></div>
        <table width="100%" border="0">
          <tr
            v-for="(lf, lfIndex) in dl.footer"
            :key="`line-footer-row-${dataPerDoc.delivery_order_code}-${lfIndex}`"
          >
            <td
              v-for="(col, colIndex) in lf"
              :key="`line-footer-col-${dataPerDoc.delivery_order_code}-${lfIndex}-${colIndex}`"
              :colspan="col.colspan"
              :rowspan="col.rowspan"
              :style="col.style"
            >
              <div v-html="col.value"></div>
            </td>
          </tr>
        </table>

        <!-- va banks -->
        <div style="height: 2px"></div>
        <table width="100%" border="0">
          <tr
            v-for="(lvb, lvbIndex) in dl.va_bank"
            :key="`line-va_bank-row-${dataPerDoc.delivery_order_code}-${lvbIndex}`"
          >
            <td
              v-for="(col, colIndex) in lvb"
              :key="`line-va_bank-col-${dataPerDoc.delivery_order_code}-${lvbIndex}-${colIndex}`"
              :colspan="col.colspan"
              :rowspan="col.rowspan"
              :style="col.style"
            >
              <div v-html="col.value"></div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import angkaTerbilang from "@develoka/angka-terbilang-js";

export default {
  name: "ProformaInvoicePrint",
  data() {
    return {
      doIds: [],
      datas: [],
      is_pod: false,
      printDatetime: moment().format("DD.MM.YYYY HH:mm:ss"),
      allData: [],
      MAX_VA_DISPLAY: 9,
    };
  },
  mounted() {
    this.doIds = window.opener.doIds;
    this.is_pod = window.opener.is_pod;
    if (this.doIds.length) {
      this.print();
    }
  },
  methods: {
    async print() {
      await this.getData();
      const tempTitle = document.title;
      await window.print();
      document.title = tempTitle;
    },
    async getData() {
      this.$vs.loading();
      let resp = await this.$http.get(`/api/wms/v1/simple-outbound-planner/surat-jalan2`,
        {
          params: {
            delivery_order_ids: this.doIds,
            is_print: 1,
            is_pod: this.is_pod,
          },
        }
      );
      if (resp.code == 200) {
        this.datas = resp.data;
        document.title = this.datas.reduce(
          (prev, curr) => `${prev}-${curr.delivery_order_code}`,
          "Surat_Jalan"
        );

        var allData = [];

        // notes
        // per page kurang lebih 32 lines
        this.datas.forEach((data) => {
          var rowHeaders = [];
          var lines = [];
          rowHeaders = [
            ...rowHeaders,
            ...this.rowDataWithLabel(
              "Alamat",
              data.warehouse_address,
              90,
              4,
              "width:132px",
              "width:5px",
              "width:657px"
            ),
          ];

          var leftColumn = this.leftColumnRowData(data);
          var rightColumn = this.rightColumnRowData(data);

          var rightLeftJoin = [];
          leftColumn.forEach((leftCol, indexCol) => {
            var rowCol = [];
            leftCol.forEach((col) => {
              rowCol.push(col);
            });
            if (rightColumn[indexCol]) {
              rightColumn[indexCol].forEach((col) => {
                rowCol.push(col);
              });
            }
            rightLeftJoin.push(rowCol);
          });

          rowHeaders = [...rowHeaders, ...rightLeftJoin];
          var rowLineHeaders = this.itemLineHeaders(data);
          var rowLineFooters = this.itemLineFooters(data);
          var rowSignatures = this.signatures(data);
          var rowFooter = this.footers(data);

          var vaBankData = (data.va_bank || []).slice(0, this.MAX_VA_DISPLAY);
          let vaPageCapacity = 0;

          var maxLine = 35;
          var maxBody = maxLine - rowHeaders.length;

          // console.log("rowHeaders.length =>", rowHeaders.length)
          // console.log("rowLineHeaders.length =>", rowLineHeaders.length)
          // console.log("rowLineFooters.length =>", rowLineFooters.length)
          // console.log("rowSignatures.length =>", rowSignatures.length)
          // console.log("rowFooter.length =>", rowFooter.length)
          // console.log("vaBankData.length =>", vaBankData.length)
          // console.log("maxBody =>", maxBody)

          lines = this.itemLines(data.lines, data.is_pbf); // line item

          var spaceBetweenTableItemAndFooterTotal = 0;
          var spaceBetweenTableItemAndFooter = [];
          var tempLines = [];
          var tempLineGroups = [];
          var tempMaxBody = maxBody;
          var isNewPage = true;

          lines.forEach((lineGroup, lgIndex) => {
            if (lgIndex == 0 || tempLineGroups.length == 0) {
              isNewPage = true;
            } else {
              isNewPage = false;
            }

            var cekBodyRowTotal = lineGroup.length;
            if (isNewPage) {
              cekBodyRowTotal += rowLineHeaders.length;
            }

            if (lgIndex == lines.length - 1 && tempMaxBody > cekBodyRowTotal) {
              if (tempMaxBody - cekBodyRowTotal - rowLineFooters.length - rowSignatures.length >= 0) {
                tempLineGroups.push(lineGroup);
                tempLines.push({
                  header: rowHeaders,
                  item_body: tempLineGroups,
                  item_header: rowLineHeaders,
                  item_footer: rowLineFooters,
                  siganture_sec: rowSignatures,
                  footer: [],
                  va_bank: [],
                });

                spaceBetweenTableItemAndFooterTotal = maxBody - rowFooter.length;

                console.log("sisa part 2 =>", spaceBetweenTableItemAndFooterTotal)

                spaceBetweenTableItemAndFooter = [];
                spaceBetweenTableItemAndFooter = [
                  ...spaceBetweenTableItemAndFooter,
                  ...rowFooter,
                ];

                if (spaceBetweenTableItemAndFooterTotal > 0 && vaBankData.length <= spaceBetweenTableItemAndFooterTotal) {
                  // menampilkan dalam 1 halaman footer
                  vaPageCapacity = spaceBetweenTableItemAndFooterTotal
                } else {
                  // menampilkan 2 halaman footer
                  vaPageCapacity = Math.max(spaceBetweenTableItemAndFooterTotal, 0)
                }

                this.pushVaBankPages(
                  tempLines,
                  data,
                  rowHeaders,
                  spaceBetweenTableItemAndFooter,
                  vaPageCapacity
                );
              } else {
                tempLineGroups.push(lineGroup);
                tempLines.push({
                  header: rowHeaders,
                  item_body: tempLineGroups,
                  item_header: rowLineHeaders,
                  item_footer: rowLineFooters,
                  siganture_sec: [],
                  footer: [],
                  va_bank: [],
                });

                if (maxBody - rowSignatures.length - rowFooter.length >= 0) {
                  // masuk kondisi 6
                  spaceBetweenTableItemAndFooterTotal = maxBody - rowSignatures.length - rowFooter.length
                  console.log("sisa part 6 =>", spaceBetweenTableItemAndFooterTotal)

                  spaceBetweenTableItemAndFooter = [];
                  spaceBetweenTableItemAndFooter = [
                    ...spaceBetweenTableItemAndFooter,
                    ...rowFooter,
                  ];

                  if (spaceBetweenTableItemAndFooterTotal > 0 && vaBankData.length <= spaceBetweenTableItemAndFooterTotal) {
                    // menampilkan dalam 1 halaman footer
                    vaPageCapacity = spaceBetweenTableItemAndFooterTotal

                    tempLines.push({
                      header: rowHeaders,
                      item_body: [],
                      item_header: [],
                      item_footer: [],
                      siganture_sec: rowSignatures,
                      footer: spaceBetweenTableItemAndFooter,
                      va_bank: this.vaBanks(data, 0, vaPageCapacity),
                    });
                  } else {
                    // menampilkan 2 halaman footer
                    vaPageCapacity = Math.max(spaceBetweenTableItemAndFooterTotal, 0)

                    tempLines.push({
                      header: rowHeaders,
                      item_body: [],
                      item_header: [],
                      item_footer: [],
                      siganture_sec: rowSignatures,
                      footer: spaceBetweenTableItemAndFooter,
                      va_bank: this.vaBanks(data, 0, vaPageCapacity),
                    });

                    const firstPageVaCount = Math.min(vaBankData.length, vaPageCapacity);
                    const remainingVaCount = vaBankData.length - firstPageVaCount;

                    if (remainingVaCount > 0) {
                      tempLines.push({
                        header: rowHeaders,
                        item_body: [],
                        item_header: [],
                        item_footer: [],
                        siganture_sec: [],
                        footer: [],
                        va_bank: this.vaBanks( data, firstPageVaCount, remainingVaCount),
                      });
                    }
                  }
                } else {
                  tempLines.push({
                    header: rowHeaders,
                    item_body: [],
                    item_header: [],
                    item_footer: [],
                    siganture_sec: rowSignatures,
                    footer: [],
                    va_bank: [],
                  });

                  spaceBetweenTableItemAndFooterTotal = maxBody - rowFooter.length;

                  console.log("sisa part 3 =>", spaceBetweenTableItemAndFooterTotal)

                  spaceBetweenTableItemAndFooter = [];
                  spaceBetweenTableItemAndFooter = [
                    ...spaceBetweenTableItemAndFooter,
                    ...rowFooter,
                  ];

                  if (spaceBetweenTableItemAndFooterTotal > 0 && vaBankData.length <= spaceBetweenTableItemAndFooterTotal) {
                    // menampilkan dalam 1 halaman footer
                    vaPageCapacity = spaceBetweenTableItemAndFooterTotal
                  } else {
                    // menampilkan 2 halaman footer
                    vaPageCapacity = Math.max(spaceBetweenTableItemAndFooterTotal, 0)
                  }

                  this.pushVaBankPages(
                    tempLines,
                    data,
                    rowHeaders,
                    spaceBetweenTableItemAndFooter,
                    vaPageCapacity
                  );
                }
              }
            } else {
              // not last item
              if (tempMaxBody - cekBodyRowTotal > cekBodyRowTotal) {
                tempLineGroups.push(lineGroup);
                tempMaxBody -= cekBodyRowTotal;
              } else {
                // new page
                tempLines.push({
                  header: rowHeaders,
                  item_body: tempLineGroups,
                  item_header: tempLineGroups.length > 0 ? rowLineHeaders : [],
                  item_footer: [],
                  siganture_sec: [],
                  footer: [],
                  va_bank: [],
                });

                // reset
                tempLineGroups = [];
                tempLineGroups.push(lineGroup);
                tempMaxBody = maxBody - lineGroup.length - rowLineHeaders.length;

                if (lgIndex == lines.length - 1) {
                  // console.log("kondisi item terakhir dari page sebelumnya tidak cukup")
                  spaceBetweenTableItemAndFooterTotal = tempMaxBody - cekBodyRowTotal - rowLineFooters.length - rowSignatures.length - rowFooter.length;

                  console.log("sisa part 4 =>", spaceBetweenTableItemAndFooterTotal)

                  spaceBetweenTableItemAndFooter = [];
                  spaceBetweenTableItemAndFooter = [
                    ...spaceBetweenTableItemAndFooter,
                    ...rowFooter,
                  ];

                  if (spaceBetweenTableItemAndFooterTotal > 0 && vaBankData.length <= spaceBetweenTableItemAndFooterTotal) {
                    // menampilkan dalam 1 halaman footer
                    vaPageCapacity = spaceBetweenTableItemAndFooterTotal

                    tempLines.push({
                      header: rowHeaders,
                      item_body: tempLineGroups,
                      item_header: tempLineGroups.length > 0 ? rowLineHeaders : [],
                      item_footer: rowLineFooters,
                      siganture_sec: rowSignatures,
                      footer: spaceBetweenTableItemAndFooter,
                      va_bank: this.vaBanks(data, 0, vaPageCapacity),
                    });
                  } else {
                    // menampilkan 2 halaman footer
                    vaPageCapacity = Math.max(spaceBetweenTableItemAndFooterTotal, 0)

                    tempLines.push({
                      header: rowHeaders,
                      item_body: tempLineGroups,
                      item_header: tempLineGroups.length > 0 ? rowLineHeaders : [],
                      item_footer: rowLineFooters,
                      siganture_sec: rowSignatures,
                      footer: spaceBetweenTableItemAndFooter,
                      va_bank: this.vaBanks(data, 0, vaPageCapacity),
                    });

                    const firstPageVaCount = Math.min(vaBankData.length, vaPageCapacity);
                    const remainingVaCount = vaBankData.length - firstPageVaCount;

                    if (remainingVaCount > 0) {
                      tempLines.push({
                        header: rowHeaders,
                        item_body: [],
                        item_header: [],
                        item_footer: [],
                        siganture_sec: [],
                        footer: [],
                        va_bank: this.vaBanks( data, firstPageVaCount, remainingVaCount),
                      });
                    }
                  }
                }
              }
            }
          });

          allData.push({
            delivery_order_code: data.delivery_order_code,
            company_name: data.company_name,
            is_pbf: data.is_pbf,
            lines: tempLines,
          });
        });

        this.allData = allData;

        this.$vs.loading.close();
      } else {
        this.$vs.loading.close();
      }
    },

    itemLineHeaders(data) {
      var rows = [];
      rows.push([
        {
          value: "NO",
          colspan: "",
          rowspan: "",
          class: "",
          style:
            "font-weight: bold; text-align: left; padding: 0 2px; width: 5px",
        },
        {
          value: "Item",
          colspan: "",
          rowspan: "",
          class: "",
          style:
            "font-weight: bold; text-align: left; padding: 0 2px; width: 45px",
        },
        {
          value: "Item Name",
          colspan: "",
          rowspan: "",
          class: "text-left text-bold",
          style: "padding: 0 2px;",
        },
        ...(data.is_pbf
          ? [
              {
                value: "Batch No",
                colspan: "",
                rowspan: "",
                style:
                  "font-weight: bold; text-align: left; padding: 0 15px 0 2px; width: 30px; text-wrap-mode: nowrap",
              },
              {
                value: "Exp. Date",
                colspan: "",
                rowspan: "",
                class: "text-left text-bold",
                style: "padding: 0 2px; width: 75px",
              },
            ]
          : []),
        {
          value: "Qty",
          colspan: "",
          rowspan: "",
          class: "text-left text-bold",
          style: data.is_pbf
            ? "padding: 0 2px 0 8px; width: 30px"
            : "padding: 0 14px 0 8px; width: 30px",
        },
        ...(data.is_pbf
          ? [
              {
                value: "",
                colspan: "",
                rowspan: "",
                class: "text-left text-bold",
                style: "padding: 0 2px; width: 120px",
              },
            ]
          : []),
        {
          value: "UOM",
          colspan: "",
          rowspan: "",
          class: "text-left text-bold",
          style: "padding: 0 2px; width: 30px",
        },
        {
          value: "Price",
          colspan: "",
          rowspan: "",
          class: "",
          style: "padding: 0 2px; width: 75px;text-align: right;",
        },
      ]);

      return rows;
    },
    itemLineFooters(data) {
      var rows = [];
      rows.push([
        {
          value: "Total Price ",
          colspan: data.is_pbf ? 8 : 5,
          rowspan: "",
          style:
            "text-align: right; padding: 0 2px; border-top: 2px dashed; font-size: 9pt;",
        },
        {
          value: this.formatNumber(data.total_price),
          colspan: "",
          rowspan: "",
          style:
            "text-align: right; padding: 0; border-top: 2px dashed; font-size: 9pt;",
        },
      ]);

      rows.push([
        {
          value: "Message :",
          colspan: data.is_pbf ? 9 : 6,
          rowspan: "",
          style: "text-align: left; padding: 0 2px; border-top: 2px dashed",
        },
      ]);
      return rows;
    },
    emptyFooters(data) {
      var rows = [];

      if (data.is_pbf) {
        rows.push([
          {
            value: "&nbsp;",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
        ]);
      } else {
        rows.push([
          {
            value: "&nbsp;",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
        ]);
      }

      return rows;
    },
    signatures(data) {
      var rows = [];

      if (data.is_pbf) {
        rows.push([
          {
            value: data.invoice_proforma_date,
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "width: 25%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "width: 25%",
          },
          {
            value: "Tanggal Diterima : . . . .",
            colspan: "",
            rowspan: "",
            style: "text-align: left; width: 25%",
          },
        ]);

        rows.push([
          {
            value: "Yang Menyerahkan",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Apoteker",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Ekspedisi",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Yang Menerima",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
        ]);

        for (let i = 0; i < 4; i++) {
          rows.push([
            {
              value: "&nbsp;",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 25%",
            },
            {
              value: "",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 25%",
            },
            {
              value: "",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 25%",
            },
            {
              value: "",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 25%",
            },
          ]);
        }

        rows.push([
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
        ]);
        rows.push([
          {
            value: "Nama Jelas",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Nama Jelas",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Nama Jelas",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
          {
            value: "Nama Jelas dan Cap",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 25%",
          },
        ]);
      } else {
        rows.push([
          {
            value: data.invoice_proforma_date,
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "",
            colspan: "",
            rowspan: "",
            style: "width: 25%",
          },
          {
            value: "Tanggal Diterima : . . . . .",
            colspan: "",
            rowspan: "",
            style: "text-align: left; width: 33.3%",
          },
        ]);

        rows.push([
          {
            value: "Yang Menyerahkan",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "Ekspedisi",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "Yang Menerima",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
        ]);

        for (let i = 0; i < 4; i++) {
          rows.push([
            {
              value: "&nbsp;",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 33.3%",
            },
            {
              value: "",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 33.3%",
            },
            {
              value: "",
              colspan: "",
              rowspan: "",
              style: "text-align: center; width: 33.3%",
            },
          ]);
        }

        rows.push([
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "( . . . . . . . . . )",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
        ]);
        rows.push([
          {
            value: "Nama Jelas",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "Nama Jelas",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
          {
            value: "Nama Jelas dan Cap",
            colspan: "",
            rowspan: "",
            style: "text-align: center; width: 33.3%",
          },
        ]);
      }

      return rows;
    },
    footers(data) {
      var rows = [];

      rows.push([
        {
          value: "<b>Ketentuan berikut berlaku secara umum dan mengikat untuk setiap transaksi dan seluruh faktur yang diterbitkan oleh perusahaan kami :</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value:
            "<b>1. Surat Jalan ini bukan merupakan bukti pembayaran yang sah.</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value:
            "<b>2. Mintalah invoice asli dan faktur pajak setiap kali akan melakukan pembayaran.</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value:
            "<b>3. Pembayaran transfer hanya dinyatakan sah dan lunas apabila ditransfer ke rekening Virtual Account (VA) resmi perusahaan yang tertera di faktur. Pembayaran di luar rekening VA tersebut tidak akan diakui dan tagihan akan tetap berstatus belum lunas, sehingga customer tetap berkewajiban membayar kepada Perusahaan sesuai tagihan.</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value:
            "<b>4. Batas maksimal permintaan revisi atau koreksi Faktur Pajak adalah tanggal 15 pada bulan berikutnya setelah bulan penerbitan invoice. Lewat dari batas waktu tersebut, Faktur Pajak dianggap sah dan customer membebaskan perusahaan dari segala tuntutan atau kewajiban perpajakan terkait di kemudian hari.</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value: "<br>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);
      rows.push([
        {
          value: "<b>Bank Account :</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        },
      ]);

      return rows;
    },
    vaBanks(data, startIndex = 0, countDisplay = 9) {
      const rows = [];
      const vaBanks = (data.va_bank || []).slice(0, 9);

      if (vaBanks.length === 0 && startIndex === 0) {
        rows.push([{
          value: "<b>Nomor Virtual Account belum tersedia</b>",
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        }]);

        return rows;
      }

      vaBanks
      .slice(startIndex, startIndex + countDisplay)
      .forEach((val, index) => {
        const text = `${startIndex + index + 1}. ${val.account_number} - ${val.bank_name}`;

        rows.push([{
          value: `<b>${text}</b>`,
          colspan: data.is_pbf ? 4 : 3,
          rowspan: "",
          style: "text-align: left;",
        }]);
      });

      return rows;
    },
    pushVaBankPages(tempLines, data, rowHeaders, footerRows, vaPageCapacity) {
      const vaBankData = (data.va_bank || []).slice(0, this.MAX_VA_DISPLAY);
      const firstPageVaCount = Math.min(vaBankData.length, Math.max(vaPageCapacity, 0));
      const remainingVaCount = vaBankData.length - firstPageVaCount;

      // Halaman pertama: footer utama + VA yang masih muat
      tempLines.push({
        header: rowHeaders,
        item_body: [],
        item_header: [],
        item_footer: [],
        siganture_sec: [],
        footer: footerRows,
        va_bank: this.vaBanks(data, 0, firstPageVaCount),
      });

      // Halaman selanjutnya: hanya sisa VA Banks
      if (remainingVaCount > 0) {
        tempLines.push({
          header: rowHeaders,
          item_body: [],
          item_header: [],
          item_footer: [],
          siganture_sec: [],
          footer: [],
          va_bank: this.vaBanks(data, firstPageVaCount, remainingVaCount),
        });
      }

      return tempLines;
    },

    itemLines(lines, isPbf = false) {
      var rowGroups = [];
      lines.forEach((line, lIndex) => {
        var rowGroupSubs = [];

        var tempColRowNumber = [];
        var tempColItemCode = [];
        var tempColItemName = [];
        var tempColBatchNo = [];
        var tempColEd = [];
        var tempColQty = [];
        var tempColTerbilang = [];
        var tempColUom = [];
        var tempColPrice = [];

        tempColRowNumber.push({
          value: lIndex + 1,
          colspan: "",
          rowspan: "",
          style: "padding-left:2px; text-align: center",
        });

        tempColItemCode.push({
          value: line.sku_code,
          colspan: "",
          rowspan: "",
          style: "padding-left:2px;",
        });

        var maxLengthItemName = 60;
        if (isPbf) {
          maxLengthItemName = 30;
        }

        this.splitText(line.item_name, maxLengthItemName).forEach(
          (lineItemName) => {
            tempColItemName.push({
              value: lineItemName,
              colspan: "",
              rowspan: "",
              style: "padding-left:2px; ",
            });
          }
        );

        if (isPbf) {
          /* tempColBatchNo.push({
            value: line.batch_external,
            colspan: "",
            rowspan: "",
            style: "padding-left:2px; padding-right: 6px",
          }); */

          this.splitBatch(line.batch_external, 15).forEach(lineBatch => {
            tempColBatchNo.push({
              value: lineBatch,
              colspan: "",
              rowspan: "",
              style: "padding-left:2px; padding-right: 6px",
            });
          })

          tempColEd.push({
            value: line.expired_date,
            colspan: "",
            rowspan: "",
            style: "padding-left:2px; text-align: left",
          });

          var terbilangSplit = this.splitText(
            angkaTerbilang(line.qty).toUpperCase(),
            16
          );
          terbilangSplit.forEach((lineTerbilang) => {
            tempColTerbilang.push({
              value: lineTerbilang,
              colspan: "",
              rowspan: "",
              style: "padding-left:2px;",
            });
          });
        }

        tempColQty.push({
          value: line.qty,
          colspan: "",
          rowspan: "",
          style: "padding-left:8px; text-align: left",
        });

        tempColUom.push({
          value: line.item_unit,
          colspan: "",
          rowspan: "",
          style: "padding-left:2px; text-align: left",
        });

        tempColPrice.push({
          value: this.formatNumber(line.total),
          colspan: "",
          rowspan: "",
          style: "padding-left:2px; text-align: right",
        });

        var dataLoop = [];
        const maxLines = Math.max(tempColItemName.length, tempColTerbilang.length, tempColBatchNo.length)

        if (maxLines == tempColItemName.length) {
          dataLoop = tempColItemName;
        } else if (maxLines == tempColTerbilang.length) {
          dataLoop = tempColTerbilang;
        } else {
          dataLoop = tempColBatchNo;
        }

        /* if (tempColItemName.length > tempColTerbilang.length) {
          dataLoop = tempColItemName;
        } else {
          dataLoop = tempColTerbilang;
        } */

        dataLoop.forEach((dataLoopItem, indexLoop) => {
          var colGroupSubs = [];

          if (tempColRowNumber[indexLoop]) {
            colGroupSubs.push(tempColRowNumber[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          if (tempColItemCode[indexLoop]) {
            colGroupSubs.push(tempColItemCode[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          if (tempColItemName[indexLoop]) {
            colGroupSubs.push(tempColItemName[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          if (isPbf) {
            if (tempColBatchNo[indexLoop]) {
              colGroupSubs.push(tempColBatchNo[indexLoop]);
            } else {
              colGroupSubs.push({
                value: "",
                colspan: "",
                rowspan: "",
                style: "",
              });
            }

            if (tempColEd[indexLoop]) {
              colGroupSubs.push(tempColEd[indexLoop]);
            } else {
              colGroupSubs.push({
                value: "",
                colspan: "",
                rowspan: "",
                style: "",
              });
            }
          }

          if (tempColQty[indexLoop]) {
            colGroupSubs.push(tempColQty[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          if (isPbf) {
            if (tempColTerbilang[indexLoop]) {
              colGroupSubs.push(tempColTerbilang[indexLoop]);
            } else {
              colGroupSubs.push({
                value: "",
                colspan: "",
                rowspan: "",
                style: "",
              });
            }
          }

          if (tempColUom[indexLoop]) {
            colGroupSubs.push(tempColUom[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          if (tempColPrice[indexLoop]) {
            colGroupSubs.push(tempColPrice[indexLoop]);
          } else {
            colGroupSubs.push({
              value: "",
              colspan: "",
              rowspan: "",
              style: "",
            });
          }

          rowGroupSubs.push(colGroupSubs);
        });

        rowGroups.push(rowGroupSubs);
      });
      return rowGroups;
    },

    splitText(text, maxLength) {
      const words = text.split(" ");
      const lines = [];
      let currentLine = "";

      words.forEach((word) => {
        if ((currentLine + " " + word).trim().length <= maxLength) {
          currentLine = (currentLine + " " + word).trim();
        } else {
          lines.push(currentLine);
          currentLine = word;
        }
      });

      if (currentLine) {
        lines.push(currentLine);
      }
      return lines;
    },
    splitBatch(text, maxLength) {
      if (!text) return [""];

      const separators = ["-", ".", "/", "(", ")", "#"];
      const tolerance = 3;

      const lines = [];
      let start = 0;

      while (start < text.length) {
        if (text.length - start <= maxLength) {
          lines.push(text.substring(start).trim());
          break;
        }

        let end = start + maxLength;

        // cari separator setelah batas maxLength
        let separatorPos = -1;

        for (let i = end; i < Math.min(end + tolerance + 1, text.length); i++) {
          if (separators.includes(text[i])) {
            separatorPos = i;
            break;
          }
        }

        if (separatorPos !== -1) {
          // separator ikut BARIS BERIKUTNYA
          end = separatorPos;
        }

        lines.push(text.substring(start, end).trimEnd());

        start = end;

        // hilangkan spasi di awal baris berikutnya
        while (start < text.length && text[start] === " ") {
          start++;
        }
      }

      return lines;
    },
    rowDataWithLabel(
      label,
      textValue,
      maxLength,
      colspan = "",
      style1 = "",
      style2 = "",
      style3 = ""
    ) {
      var rowData = [];
      var rowLine = this.splitText(textValue, maxLength);

      if (rowLine.length == 0) {
        var colData = [];
        colData.push({
          value: "",
          colspan: "",
          rowspan: "",
          style: style1,
        });
        colData.push({
          value: "",
          colspan: "",
          rowspan: "",
          style: style2,
        });
        colData.push({
          value: "",
          colspan: colspan,
          rowspan: "",
          style: style3,
        });

        rowData.push(colData);
      }

      rowLine.forEach((line, index) => {
        var colData = [];
        if (index == 0) {
          colData.push({
            value: label,
            colspan: "",
            rowspan: "",
            style: style1,
          });
          colData.push({
            value: ":",
            colspan: "",
            rowspan: "",
            style: style2,
          });
          colData.push({
            value: line,
            colspan: colspan,
            rowspan: "",
            style: style3,
          });
        } else {
          colData.push({
            value: "",
            colspan: "",
            rowspan: "",
            style: style1,
          });
          colData.push({
            value: "",
            colspan: "",
            rowspan: "",
            style: style2,
          });
          colData.push({
            value: line,
            colspan: colspan,
            rowspan: "",
            style: style3,
          });
        }
        rowData.push(colData);
      });

      return rowData;
    },

    leftColumnRowData(data) {
      var rowData = [];
      var colData = [];
      var maxLength = 26;

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "N.P.W.P",
          "01.604.506.4-007.000",
          maxLength,
          "",
          "width:132px",
          "width:5px",
          "width:190px"
        ),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel("NITKU", data.company_nitku, maxLength, 0, ""),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "No.Pengukuhan PKP",
          "01.604.506.4-007.000",
          maxLength,
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Tgl. Pengukuhan",
          "09-04-2007",
          maxLength,
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel("Vendor Transportir", "-", maxLength, 0, ""),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Vehicle No.",
          data.vehicle_number,
          maxLength,
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Driver Name",
          data.driver_name,
          maxLength,
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Kepada Yth",
          data.customer_code + " " + data.customer_name,
          maxLength,
          "",
          ""
        ),
      ];

      var customerAddressSplit = this.splitText(data.customer_address, 43);
      customerAddressSplit.forEach((line, index) => {
        colData = [];
        if (index < 4) {
          colData.push({
            value: line,
            colspan: 3,
            rowspan: "",
            style: "",
          });

          rowData.push(colData);
        }
      });

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel("NPWP", data.customer_npwp, maxLength, 0, ""),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "NITKU",
          data.customer_nitku ? data.customer_nitku : "-",
          maxLength,
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Sold-To Code / Name",
          data.bill_to_code + " / " + data.bill_to_name,
          maxLength,
          "",
          ""
        ),
      ];

      return rowData;
    },

    rightColumnRowData(data) {
      var rowData = [];
      var maxLength = 39;

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel("", "", maxLength, 0, ""),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "No.DO / No.SO",
          data.delivery_order_code + " / " + data.sales_order_code,
          maxLength,
          0,
          "white-space: nowrap;width: 170px",
          "",
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Tgl. Transaksi",
          data.invoice_proforma_date,
          maxLength,
          0,
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Syarat Pembayaran",
          data.payment_term_name + " / " + data.sales_order_date,
          maxLength,
          0,
          ""
        ),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Tgl. Kadaluarsa",
          data.invoice_proforma_due_date,
          maxLength,
          0,
          ""
        ),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel("PO No.", "-", maxLength, 0, ""),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Kode / Salesman",
          data.sales_code + " / " + data.sales_name,
          maxLength,
          0,
          ""
        ),
      ];
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Ref. No.",
          data.so_reference_code,
          maxLength,
          0,
          ""
        ),
      ];
      if (data.is_pbf) {
        rowData = [
          ...rowData,
          ...this.rowDataWithLabel(
            "PBF. No.",
            data.pbf_no ? data.pbf_no : "-",
            maxLength,
            0,
            ""
          ),
        ];
        rowData = [
          ...rowData,
          ...this.rowDataWithLabel(
            "IPAK. No.",
            data.ipak_no ? data.ipak_no : "-",
            maxLength,
            0,
            ""
          ),
        ];
        rowData = [
          ...rowData,
          ...this.rowDataWithLabel(
            "CDOB. No.",
            data.codb_no ? data.codb_no : "-",
            maxLength,
            0,
            ""
          ),
        ];
      }
      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Print Counter / datetime",
          data.print_counter + " / " + this.printDatetime,
          maxLength,
          0,
          ""
        ),
      ];

      rowData = [
        ...rowData,
        ...this.rowDataWithLabel(
          "Doc. Type",
          data.document_type,
          maxLength,
          0,
          ""
        ),
      ];

      return rowData;
    },
  },
  watch: {},
  computed: {
    formatNumber: () => {
      return (val) => {
        if (val == null) {
          return 0;
        }
        return Intl.NumberFormat("id", { minimumFractionDigits: 0 }).format(
          val
        );
      };
    },
  },
};
</script>
